var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-item-quantity-selector"},[_c('div',{staticClass:"decrease",on:{"click":_vm.decreaseQuantity}},[_vm._v("-")]),_c('div',{staticClass:"tp-text-subtitle-semibold"},[_vm._v(_vm._s(_vm.quantity))]),_c('div',{staticClass:"increase",on:{"click":_vm.increaseQuantity}},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }